const state = {
  upload: false
}

const mutations = {
  SET_UPLOAD(state, status) {
    state.upload = status
  }
}

export default {
  state,
  mutations
}
